export default __webpack_public_path__ + "static/media/fin-option-inactive.d7595bc9.svg";